import { ETheme } from "@/common/entity/Enum";
import styled from "styled-components";

export const ResourceFilterBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  background-color: ${(props) =>
    props.$theme === ETheme.Dark
      ? "rgba(71, 158, 245, 0.05)"
      : "rgba(16, 110, 190, 0.05)"};

  .dropdown-filter .wrapper-dropdown .icon-left,
  .dropdown-filter .wrapper-dropdown .text-left {
    left: 12px;
  }

  .dropdown-filter .wrapper-dropdown button {
    padding-left: 36px;
  }

  .mb_8 {
    margin-bottom: 8px;
  }
  .mt-8 {
    margin-top: 8px;
  }
  .dropdown-filter .fui-Input {
    min-height: 28px !important;
  }
  .pr-4 {
    padding-right: 4px !important;
  }
  .pl-4 {
    padding-left: 4px !important;
  }
  .custom-dropdown {
    .fui-Dropdown {
      min-width: 100% !important;
      height: 28px;
    }
    .fui-Option {
      font-size: 12px;
    }
    .fui-Dropdown__clearButton {
      font-size: 14px;
      margin-right: 6px;
    }
  }
  .custom-checkbox {
    .fui-Label {
      font-size: 12px;
      margin-left: -4px;
    }
    .fui-Checkbox {
      margin: -4px !important;
      margin-top: -8px !important;
    }
  }
  .custom-option {
    font-size: 12px;
  }
`;

export const ResourceFilterGridWrapper = styled.div<{ $theme?: string }>`
  padding: 8px !important;

  .custom_search {
    .fui-Input__contentAfter {
      height: 28px;
      display: flex;
      align-items: center;
    }
    .fui-Switch__label {
      font-size: 12px;
    }
  }
`;
